import React from 'react';

export type GradingSubPageTab = 'grading' | 'ujian-bertulis' | 'leaderboard' | 'settings';

export interface GradingMetric {
  value: string | number;
  label: string;
  colorClass?: string;
}

export interface GradingHeaderHeroProps {
  activeTab?: GradingSubPageTab;
  badgeTag: string;
  badgeIcon?: any;
  badgeColorClass?: string;
  title: string;
  subtitle: string;
  metrics?: GradingMetric[];
  children?: React.ReactNode;
}

export const GradingHeaderHero: React.FC<GradingHeaderHeroProps> = ({
  badgeTag,
  badgeColorClass = 'bg-red-50 text-red-700 border-red-200/80',
  title,
  subtitle,
  metrics,
  children,
}) => {
  return (
    <div className="mb-6 sm:mb-8 animate-fade-in">
      {/* MAIN ROUNDED HERO CARD ON PURE WHITE CANVAS */}
      <div className="bg-white rounded-3xl border border-slate-200/90 p-5 sm:p-8 shadow-xs text-center relative">
        {/* Hero Tag & Title & Subtitle */}
        <div className="max-w-2xl mx-auto">
          <div className={`inline-flex items-center px-3 py-1 rounded-full text-[11px] sm:text-xs font-bold mb-2 border ${badgeColorClass}`}>
            <span>{badgeTag}</span>
          </div>

          <h1 className="text-xl sm:text-3xl font-extrabold text-slate-900 tracking-tight">
            {title}
          </h1>

          <p className="text-xs sm:text-sm text-slate-600 font-medium mt-1.5 leading-relaxed">
            {subtitle}
          </p>
        </div>

        {/* Optional Contextual Children (e.g. Leaderboard facet buttons or alerts) */}
        {children && <div className="mt-4">{children}</div>}

        {/* NESTED STANDARDIZED FLOATING METRIC PILL BAR */}
        {metrics && metrics.length > 0 && (
          <div className="grid grid-cols-2 sm:flex sm:items-center sm:justify-around gap-2.5 sm:gap-6 bg-slate-50 sm:bg-white p-3 sm:py-2.5 sm:px-6 rounded-2xl sm:rounded-full border border-slate-200/80 shadow-xs max-w-2xl mx-auto mt-5 sm:mt-6">
            {metrics.map((m, idx) => (
              <React.Fragment key={m.label}>
                {idx > 0 && <div className="hidden sm:block h-4 w-px bg-slate-200" />}
                <div className="text-center p-1.5 sm:p-0">
                  <span className={`text-base sm:text-lg font-black ${m.colorClass || 'text-slate-900'}`}>
                    {m.value}
                  </span>
                  <span className="text-[11px] sm:text-xs text-slate-500 font-medium ml-1.5">
                    {m.label}
                  </span>
                </div>
              </React.Fragment>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};
